import { eventBus } from '@eventBus'
import cSocket from './cSocket'
export default {
    data() {
        return {
            telList_cSocket: null
        }
    },
    methods: {
        telList_initSocket() {

            this.telList_cSocket = new cSocket({
                //wss: 'wss://new-8003.fleetsoft.pro',
                wss: 'wss://new-8003.fleetsoft.pro',
                token: this.user.token,
                name: '8003',
                onmessage: this.telList_onmessage,
                onErrorConnection: this.onErrorConnetion,
                loopReconnect: true,
                reconnectTime: 60000,
                //console: false
            })
            eventBus.$on('socketEmit_telList', this.telList_cSocket.emit.bind(this.telList_cSocket));
            eventBus.$on('socketEmit_telList_callEvent', this.telList_cSocket.emit.bind(this.telList_cSocket));
        },
        telList_onmessage(action, data) {
            switch (action) {
                case 'action_update_status':
                    eventBus.$emit('action_update_status', data);
                    break;
                case 'has_incoming':
                    eventBus.$emit('action_update_status_user', data);
                    break;
                default:
                    break;
            }
        },

        onErrorConnetion() {
            console.log('errorConnection')
            eventBus.$emit('errorConnection')
        },
    }
}